var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegenerate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21 9.73132C20.6943 7.5316 19.6738 5.4934 18.0958 3.93069C16.5178 2.36799 14.4697 1.36747 12.2671 1.08326C10.0645 0.799056 7.82953 1.24692 5.9065 2.35788C3.98348 3.46883 2.47906 5.18124 1.625 7.23132M1 2.23132V7.23132H6M1 12.2314C1.3057 14.4311 2.32616 16.4693 3.9042 18.032C5.48224 19.5947 7.5303 20.5952 9.73291 20.8794C11.9355 21.1637 14.1705 20.7158 16.0935 19.6048C18.0165 18.4939 19.5209 16.7815 20.375 14.7314M21 19.7314V14.7314H16",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegenerate);
export default __webpack_public_path__ + "static/media/regenerate.9dcebb378f237305f77889cab3558113.svg";
export { ForwardRef as ReactComponent };